import { render, staticRenderFns } from "./benfeitoria-icon.vue?vue&type=template&id=0ab83925"
import script from "./benfeitoria-icon.vue?vue&type=script&lang=js"
export * from "./benfeitoria-icon.vue?vue&type=script&lang=js"
import style0 from "./benfeitoria-icon.vue?vue&type=style&index=0&id=0ab83925&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports